import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

/**
 * Components
 */
import LoginThirdParty from '@pedidosya/web-fenix/specifics/LoginThirdParty';
import BottomSheetItem from '../components/BottomSheetItem';
import { SocialContainer } from '../components/SocialLoginCommons';

import messages from './messages';

function FacebookButton({
  intl: { formatMessage },
  onClick,
  isBottomSheetButton,
}) {
  return isBottomSheetButton ? (
    <BottomSheetItem
      label={formatMessage(messages.buttonText)}
      onClick={onClick}
    />
  ) : (
    <SocialContainer onClick={onClick}>
      <LoginThirdParty type="facebook" role="button" />
    </SocialContainer>
  );
}

FacebookButton.defaultProps = {
  isBottomSheetButton: false,
};

FacebookButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isBottomSheetButton: PropTypes.bool,
};

export default injectIntl(FacebookButton);
